import React from 'react';
import * as Yup from 'yup';

export const SupportTicketMessageValidatorSchema = Yup.object().shape({
    text: Yup.string()
        .min(2, 'tooShort')
        .required('required')
});